module.exports = __webpack_public_path__ + "img/jbtyk04.9c7a77c5.png";